module.exports = __webpack_public_path__ + "slide4.591976b003e0290464cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide4.jpg
// module id = ./src/assets/images/private/home/slide4.jpg
// module chunks = main